import React, { useCallback } from 'react';
import { Checkbox, MenuItem } from '@chakra-ui/react';
import { getAllowedParks } from 'routes/OffshoreActivity/OffshoreActivity.utils';
import { useRematchSelector } from 'models/rematchStore';

const MAX_PARKS_SELECTED = 4;

export const ParkMenuItems = ({ group, saveGroup }) => {
    const parkList = useRematchSelector((state) => state.appData.parkList);
    const allowedScreens = useRematchSelector((state) => state.account.allowedScreens);
    const parks = getAllowedParks({ parkList, allowedScreens });

    const onChange = useCallback(
        (e, parkItem) => {
            const { checked } = e.target;

            const newItems = group.checkedItems ? [...group.checkedItems] : [];

            if (checked) {
                newItems.push(parkItem.value);
            } else {
                const index = newItems.indexOf(parkItem.value);
                if (index > -1) {
                    newItems.splice(index, 1);
                }
            }

            saveGroup(group.groupId, { checkedItems: newItems });
        },
        [group.checkedItems, group.groupId, saveGroup]
    );

    const disableRest = group.checkedItems?.length >= MAX_PARKS_SELECTED;

    return parks.map((item) => {
        const checked = group.checkedItems?.includes(item.value);
        return (
            <MenuItem>
                <Checkbox
                    spacing="18px"
                    key={item.text}
                    disabled={disableRest && !checked}
                    defaultChecked={checked}
                    onChange={(e) => onChange(e, item)}>
                    {item.text}
                </Checkbox>
            </MenuItem>
        );
    });
};
